// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const WarningIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M4.36 21.54h-.04q-.5-.04-.97-.22c-1.52-.61-2.25-2.35-1.63-3.87L9.4 3.98c.26-.47.66-.88 1.15-1.15 1.43-.79 3.25-.27 4.04 1.16l7.64 13.37c.17.4.24.72.26 1.06.04.79-.23 1.55-.77 2.14-.53.59-1.26.94-2.05.98z"
        opacity=".5"
      />
      <path d="M12 15.47c.5 0 .92.41.92.91 0 .52-.41.93-.92.93-.5 0-.92-.4-.92-.92 0-.5.41-.92.92-.92m0-6.56c.5 0 .92.42.92.92v2.97c0 .51-.41.92-.92.92-.5 0-.92-.41-.92-.92V9.83c0-.5.41-.92.92-.92" />
    </g>
  </SvgIcon>
);

export default WarningIcon;
